import { render, staticRenderFns } from "./talkAside.vue?vue&type=template&id=633c0441&scoped=true&"
import script from "./talkAside.vue?vue&type=script&lang=js&"
export * from "./talkAside.vue?vue&type=script&lang=js&"
import style0 from "./talkAside.vue?vue&type=style&index=0&id=633c0441&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633c0441",
  null
  
)

export default component.exports